import React from 'react'

import styles from './WelcomeStep.module.scss'

const WelcomeStep = ({ variant }: { variant: 'first' | 'second' | 'third' }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.img} />

      <h1 className={styles.title}>ФУНКЦІЯ {variant === 'first' ? 'ОДИН' : variant === 'second' ? 'ДВА' : 'ТРИ'}</h1>
      <p className={styles.subtitle}>Будьте в курсі всіх новин, оновлень та повідомлень про будівництво. </p>

      <div className={styles.pagination}>
        <span className={variant === 'first' ? styles.active : ''}></span>
        <span className={variant === 'second' ? styles.active : ''}></span>
        <span className={variant === 'third' ? styles.active : ''}></span>
      </div>
    </div>
  )
}

export default WelcomeStep
